import { Link } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { match } from 'ts-pattern';

import { Button } from '@nesso/ui/primitives/button';

import { useAutoStartDictation } from '../../model/use-auto-start-dictation';
import { RecordingLaunchMicrophoneAccessBlocked } from './recording-launch/recording-launch-microphone-access-blocked';

export function RecordingLaunch() {
    const { phase, retry } = useAutoStartDictation();

    return (
        <div className="w-[330px] flex flex-col items-center justify-center gap-6">
            {match(phase)
                .with('blocked', () => (
                    <>
                        <RecordingLaunchMicrophoneAccessBlocked />
                        <Button variant="ghost" asChild>
                            <Link to="/dashboard">Back to dashboard</Link>
                        </Button>
                    </>
                ))
                .with('failed', () => (
                    <>
                        <p className="text-md text-center text-muted-foreground">
                            We couldn't start the recording. Check that no other app is using your
                            microphone, then try again.
                        </p>
                        <Button size="lg" className="w-full font-medium text-md" onClick={retry}>
                            Start recording
                        </Button>
                        <Button variant="ghost" asChild>
                            <Link to="/dashboard">Back to dashboard</Link>
                        </Button>
                    </>
                ))
                .otherwise(() => (
                    <div
                        className="flex flex-col items-center gap-4 text-muted-foreground"
                        role="status"
                        aria-live="polite"
                    >
                        <Loader2 className="size-8 animate-spin text-primary" />
                        <p className="text-md">Getting your microphone ready…</p>
                    </div>
                ))}
        </div>
    );
}
